export default "__VITE_ASSET__KfGnmQUR__"